"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BuildBylawsCheatSheet = void 0;
exports.buildCheatSheetContext = buildCheatSheetContext;
const toString = (value) => value != null && value !== '' ? String(value) : undefined;
const toNumber = (value) => {
    if (typeof value === 'number') {
        return Number.isFinite(value) ? value : undefined;
    }
    if (typeof value === 'string' && value.trim() !== '') {
        const parsed = Number(value);
        return Number.isFinite(parsed) ? parsed : undefined;
    }
    return undefined;
};
const toQuorumString = (value) => {
    if (value == null) {
        return undefined;
    }
    if (typeof value === 'string') {
        const trimmed = value.trim();
        return trimmed ? trimmed : undefined;
    }
    if (typeof value === 'number' && Number.isFinite(value)) {
        return String(value);
    }
    return undefined;
};
const officerLookup = [
    { key: 'officerPresident', label: 'President' },
    { key: 'officerVicePresident', label: 'Vice President' },
    { key: 'officerTreasurer', label: 'Treasurer' },
    { key: 'officerSecretary', label: 'Secretary' },
    { key: 'officerMemberAtLarge', label: 'Member-at-Large' },
    { key: 'officerCommunications', label: 'Communications Coordinator' },
    { key: 'officerVolunteerCoordinator', label: 'Volunteer Coordinator' },
    { key: 'officerViceTreasurer', label: 'Vice Treasurer' },
];
class BuildBylawsCheatSheet {
    run(ctx) {
        const startMonth = toString(ctx.fiscalYearStartMonth);
        const startDay = toNumber(ctx.fiscalYearStartDay);
        const endMonth = toString(ctx.fiscalYearEndMonth);
        const endDay = toNumber(ctx.fiscalYearEndDay);
        let fiscalYearLabel;
        if (startMonth && endMonth) {
            const startLabel = `${startMonth}${startDay ? ` ${startDay}` : ''}`;
            const endLabel = `${endMonth}${endDay ? ` ${endDay}` : ''}`;
            fiscalYearLabel = `${startLabel} – ${endLabel}`.trim();
        }
        else if (startMonth) {
            fiscalYearLabel = `${startMonth}${startDay ? ` ${startDay}` : ''}`.trim();
        }
        else if (endMonth) {
            fiscalYearLabel = `${endMonth}${endDay ? ` ${endDay}` : ''}`.trim();
        }
        else {
            fiscalYearLabel = 'TBD';
        }
        const routineLimit = toNumber(ctx.routineSpendingLimit);
        const nonBudgetedLimit = toNumber(ctx.nonBudgetedBoardLimit);
        const spendingPolicy = [];
        if (routineLimit != null) {
            spendingPolicy.push(`Routine spending limit $${routineLimit}`);
        }
        if (nonBudgetedLimit != null) {
            spendingPolicy.push(`Board approval for expenses over $${nonBudgetedLimit}`);
        }
        const checkPolicy = spendingPolicy.length > 0 ? spendingPolicy.join('; ') : 'TBD';
        const auditGate = toString(ctx.auditMethod) ?? 'Board approval required';
        const orgLabel = toString(ctx.orgName) ?? 'the organization';
        const schoolLabel = toString(ctx.schoolName) ?? 'the school';
        const purposeSummary = ctx.purposeSummary ??
            `The purpose of ${orgLabel} is to enhance and support the educational experience at ${schoolLabel}, foster closer relationships among students, parents, and teachers, and improve the school environment through volunteer and financial support.`;
        const applicability = toString(ctx.conflictApplicabilitySentence);
        const recordkeeping = toString(ctx.conflictRecordkeepingSummary);
        const defaultSummaryParts = [
            applicability,
            recordkeeping,
            'Board members should avoid conflicts and abstain from decisions where a personal interest exists.',
        ].filter(Boolean);
        const conflictOfInterestSummary = ctx.conflictOfInterestSummary ?? defaultSummaryParts.join(' ');
        const quorumRaw = ctx.quorumExecSummary ??
            ctx.quorumExecMode ??
            ctx.quorumExecBoard ??
            ctx.quorumExecNumber;
        return {
            schoolName: toString(ctx.schoolName),
            orgName: toString(ctx.orgName),
            officers: {
                president: ctx.officerPresident ? 'President' : undefined,
                vicePresident: ctx.officerVicePresident ? 'Vice President' : undefined,
                treasurer: ctx.officerTreasurer ? 'Treasurer' : undefined,
                secretary: ctx.officerSecretary ? 'Secretary' : undefined,
            },
            meetings: {
                generalFrequency: toString(ctx.meetingFrequency),
                boardFrequency: toString(ctx.meetingFrequency),
                quorum: toQuorumString(quorumRaw),
            },
            elections: {
                month: toString(ctx.electionMonth),
                termLength: toNumber(ctx.termLength),
                termLimits: toNumber(ctx.termLimit),
            },
            finances: {
                fiscalYear: fiscalYearLabel,
                checkPolicy,
                budgetApproval: auditGate,
                checkSigning: toString(ctx.checkSignersSummary),
            },
            purposeSummary,
            conflictOfInterestSummary,
            officerRoles: officerLookup
                .filter((entry) => Boolean(ctx[entry.key]))
                .map((entry) => entry.label),
        };
    }
}
exports.BuildBylawsCheatSheet = BuildBylawsCheatSheet;
function buildCheatSheetContext(ctx) {
    return new BuildBylawsCheatSheet().run(ctx);
}
